// src/components/pages/Pessoa/boot/getPessoaBootByTipo.js

export function getPessoaBootByTipo(tipo) {
    const key = String(tipo || '').toLowerCase();

    const boots = {
        pessoa: {
            funcionario: false,
            usuario: false,
        },

        colaborador: {
            funcionario: true,
            usuario: false,
            tipo: 'Física',
        },

        usuario: {
            // funcionario: false,
            // usuario: true,
            //tipo: 'Física',
        },
    };

    return boots[key] || {};
}
